import "./CareTitle.css";

interface CareTitleProps {
  children: string;
}

export const CareTitle = ({ children }: CareTitleProps) => {
  return <h2 className="care-title">{children}</h2>;
};
